import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserRole } from '../../../../controllers/UserRoleController';
import ButtonPrimary from '../../../../components/button/ButtonPrimary';
import ButtonSecondary from '../../../../components/button/ButtonSecondary';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const CreateModal = () => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const isDisabled = useMemo(() => !name.trim(), [name]);
    const navigate = useNavigate();
    
    const handleCreate = async () => {
        try {
            await createUserRole({ name });
            navigate('/user-role');
            toast.success(t('userRole.add.message'));
        } catch (error) {
            toast.error(error.message);
        };
    };
    
    const handleBack = () => {
        navigate('/user-role');
    };
    
    return (
        <div className='flex flex-col p-5 rounded-lg bg-white space-y-5'>
            <div className='flex flex-grow items-center'>
                <span className='w-36 text-xs md:text-sm'>{t('common.role.title')}:</span>
                <input
                    className={`
                        w-full px-3 py-2 rounded border border-platinum
                        hover:outline-none hover:border-grayX11
                        focus:outline-none focus:border-blackOlive text-xs md:text-sm
                    `}
                    type='text'
                    placeholder={t('common.role.placeholderText')}
                    value={name}
                    onChange={(e) => setName(e.target.value)} 
                />
            </div>
            <div className='flex justify-end space-x-5'>
                <ButtonSecondary className='h-full w-24 md:w-32 md:text-sm' onClick={handleBack}>{t('common.action.back')}</ButtonSecondary>
                <ButtonPrimary className='h-full w-24 md:w-32 md:text-sm' isDisabled={isDisabled} onClick={handleCreate}>{t('common.action.add')}</ButtonPrimary>
            </div>
        </div>
    );
};

export default CreateModal;
